<template>
  <DataListStateful
    title="Машины"
    resource="vehicles"
    store="vehicles"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Номер тягача", name: "Number", sortable: true },
        {
          title: "Перевозчик",
          name: "carrier",
          dataPath: "Carrier.Title",
          sortable: true,
        },
        { title: "Длина тягача", name: "lengthMain", sortable: true },
        { title: "Ширина тягача", name: "widthMain", sortable: true },
        { title: "Высота тягача", name: "heightMain", sortable: true },
        { title: "Объем тягача", name: "volumeMain", sortable: true },
        { title: "Длина прицепа", name: "lengthAdditional", sortable: true },
        { title: "Ширина прицепа", name: "widthAdditional", sortable: true },
        { title: "Высота прицепа", name: "heightAdditional", sortable: true },
        { title: "Объем прицепа", name: "volumeAdditional", sortable: true },
      ],
      filter: {
        trailerNumber: {
          title: "Номер тягача",
          type: "text",
        },
        carrier: {
          title: "Перевозчик",
          type: "reference",
          resource: "carriers",
        },
        lengthMain: {
          title: "Длина тягача",
          type: "decimal",
        },
        widthMain: {
          title: "Ширина тягача",
          type: "decimal",
        },
        heightMain: {
          title: "Высота тягача",
          type: "decimal",
        },
        volumeMain: {
          title: "Объем тягача",
          type: "decimal",
        },
        lengthAdditional: {
          title: "Длина прицепа",
          type: "decimal",
        },
        widthAdditional: {
          title: "Ширина прицепа",
          type: "decimal",
        },
        heightAdditional: {
          title: "Высота прицепа",
          type: "decimal",
        },
        volumeAdditional: {
          title: "Объем прицепа",
          type: "decimal",
        },
      },
    };
  },
};
</script>
